import { Component, OnInit, Input } from '@angular/core';
import { ProjectDto, ClientDto, UserRoleDto } from "../../data/CommandServiceDtos.generated";
import { faPencilAlt, faWrench, faDollyFlatbed, faClipboardList, faLink } from '@fortawesome/free-solid-svg-icons';
import { PageContainerService } from '../../services';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'project-thumbnail',
  templateUrl: './project-thumbnail.component.html',
  styleUrls: ['./project-thumbnail.component.scss']
})
export class ProjectThumbnailComponent implements OnInit {
  @Input() project: ProjectDto;
  @Input() userRoles: UserRoleDto[];
  showEditIcon: boolean = false;
  showEditIconForUser: boolean = false;
  faPencil = faPencilAlt;
  faWorkPackIcon = faWrench;
  faMaterialLink = faDollyFlatbed;
  iconExecutionLink = faClipboardList;
  faCXPlannerLink = faLink;
  cxPlannerSummaryStage: any;
  constructor(private pcs: PageContainerService, private http: HttpClient, private route: Router) {
  }

  ngOnInit() {
    this.checkUserRoles();
    if (this.project.CXPlannerIdentifiers.length > 0) {
      this.pcs.apiService.executeCommandService.getCxPlanner(this.project.CXPlannerIdentifiers[0]).then((data) => {
        this.cxPlannerSummaryStage = this.transformData(JSON.parse(data._body));
        this.cxPlannerSummaryStage.projectId = this.project.CXPlannerIdentifiers[0];
      });
    }
  }
  gotoCXPlannerDashboard(event: MouseEvent): void {
    event.stopPropagation();
    window.open("https://app.cxplanner.com/project/" + this.cxPlannerSummaryStage.projectId + "/dashboard", "_blank");
  }


  toggleEdit() {
    this.showEditIcon = !this.showEditIcon;
  }
  clientLogo(client: ClientDto) {
    if (!client.hasOwnProperty('logo'))
      return 'app/assets/images/project-placeholder.png';

    return '';
  }

  checkUserRoles() {
    this.showEditIconForUser = this.userRoles.some(role =>
      role.RoleName === 'Global Administrator' ||
      role.RoleName === 'Company Administrator' ||
      role.RoleName === 'Project Manager'
    );
  }

  hasAnyProjectIcons(project: any): boolean {
    return !!(
      project && (
        project.ReadinessAssessmentPath ||
        (project.SiteSenseIdentifiers && project.SiteSenseIdentifiers.length > 0) ||
        (project.PrimaveraIdentifiers && project.PrimaveraIdentifiers.length > 0) ||
        (project.CXPlannerIdentifiers && project.CXPlannerIdentifiers.length > 0)
      )
    );
  }

  private transformData(dataArray: any[]): any[] {
    return dataArray.map((data) => {
      return {
        SummaryStageId: data.id,
        StageName: data.name,
        PercentComplete: data.sub_per,
        Stages: data.children ? data.children.map((child: any): any => ({
          StageId: child.id,
          StageName: child.name,
          PercentComplete: child.sub_per
        })) : []
      };
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/components/project-thumbnail/project-thumbnail.component.ts